import PropTypes from 'prop-types'
import React from 'react'
import { sortBy, filter, uniq } from 'lodash'
import { compareParseInt } from 'helpers/index'
import { getBins } from 'helpers/orders'
import moment, { displayFormat } from 'helpers/moment'
import classes from './Packlists.scss'

const ordersByCustomer = (orders) => {
  return uniq(orders.map(o => o.customer_id))
    .map(customerId => {
      // sort orders by product name
      return sortBy(
        // get orders for this customer
        filter(orders, (order) => compareParseInt(customerId, order.customer_id)),
        'product.name'
      )
    }
  )
}

export const Packlist = (props) => {
  const firstOrder = props.orders.find(o => o)

  return <div className={classes.packlist}>
    <header className={classes.header}>
      <span className={classes.route}>Route {firstOrder.route.name}</span>
      <span className={classes.customer}>{firstOrder.customer.name}</span>
      <span className={classes.date}>{moment(firstOrder.date).format(displayFormat)}</span>
    </header>

    <table className={classes.table}>
      {firstOrder.customer.notes && <caption className={classes.caption}>{firstOrder.customer.notes}</caption>}

      <thead>
        <tr>
          <th className={classes.left}>name</th>
          <th className={classes.center}>qty</th>
          <th className={classes.center}>spec</th>
          <th className={classes.center}>sent</th>
          <th>notes</th>
        </tr>
      </thead>

      <tbody>
        {!!props.orders.length && props.orders.map(order => {
          const bins = getBins(order)

          return <tr key={order.id}>
            <td className={classes.left}>{order.product.name}</td>
            <td className={classes.center}>
              {order.qty} {order.uom.shorthand || order.uom.name}
              {bins && bins.length > 1 && <br />}
              {bins && bins.length > 1 && `${bins.length} Bins`}
            </td>
            <td className={classes.center}>{order.option ? order.option.name : ''}</td>
            <td className={classes.center}>
              {order.packed_qty} {order.packed_uom ? (order.packed_uom.shorthand || order.packed_uom.name) : undefined}
            </td>
            <td>
              {order.notes && <span>
                <strong>Customer Notes:</strong><br />
                {typeof order.notes === 'string' ? order.notes.replace(/\n/g, ' ') : ''}
              </span>}
              
              {order.notes && (order.packed_notes || order.packed_by) && <br />}

              {order.packed_notes && <span>
                <strong>Fulfillment Notes:</strong><br />
                {typeof order.packed_notes === 'string' ? order.packed_notes.replace(/\n/g, ' ') : ''}
              </span>}

              {order.packed_by && <div>Packed by {order.packed_by.email}</div>}
            </td>
          </tr>
        })}
      </tbody>
    </table>
  </div>
}

Packlist.propTypes = {
  orders: PropTypes.array
}

export const Packlists = (props) => {
  const customersOrders = ordersByCustomer(props.orders)
    .filter(orders => orders && orders.length)

  if (!customersOrders || !customersOrders.length) return null

  return (
    <div className={classes.packlists}>
      {customersOrders.map((orders, index) => <Packlist orders={orders} key={index} />)}
    </div>
  )
}

Packlists.propTypes = {
  orders: PropTypes.array
}

export default Packlists



// WEBPACK FOOTER //
// ./src/components/Reports/Packlists/Packlists.js